const REGEX = {
  PHONE_NUMBER: /^(0|33|\+33)\d{9}$/,
  POSTAL_CODE: /^(0[1-9]|[1-8]\d|9[0-6])\d{3}$/,
  COMPANY_NAME: /^[a-zA-Z0-9\u00C0-\u00ff '.&-]*$/,
  NAME: /^[a-zA-Z\u00C0-\u00ff '-]*$/,
}

export const isPhoneNumber = (value: string): boolean => REGEX.PHONE_NUMBER.test(value)

export const isPostalCode = (value: string): boolean => REGEX.POSTAL_CODE.test(value)

export const isCompanyName = (value: string): boolean => REGEX.COMPANY_NAME.test(value)

export const isName = (value: string): boolean => REGEX.NAME.test(value)

export const isDateOfBirth = (value: string): boolean => {
  /**
   * Any date after 1900-01-01 in the YYYY-MM-DD format.
   */
  return /^(19|[2-9][0-9])\d{2}-\d{1,2}-\d{1,2}$/.test(value)
}
